import { useQuery } from 'react-query';
import { useTranslation } from 'react-i18next';

import { KEYS } from 'helpers/react-query.config';
import { useApiContext } from 'context/ApiContext';
import { useGlobalContext } from 'context/GlobalContext';

function useGetClientsWhitOutFlow() {
  const { t } = useTranslation('global');
  const { showApiError } = useGlobalContext();
  const { processApi } = useApiContext();

  return useQuery(
    [KEYS.process.problemStatus.getClientsWhitOutFlow()],
    () => processApi.ProblemStatus.getClientsWhitOutFlow(),
    {
      refetchOnWindowFocus: false,
      select: ({ data }) =>
        data.data?.map((client) => ({
          label: client.name,
          id: client.id
        })),
      onError: (error) =>
        showApiError(error, t('common.commonMessages.genericRequestError'))
    }
  );
}

export default useGetClientsWhitOutFlow;
